/**
 * Byg fuld URL til produktbilleder.
 * I dev bruger vi proxy for /static.
 * I prod: hvis VITE_API_URL er sat (fx https://api.example.com/api),
 *         så er billeder på samme origin (https://api.example.com/static/...)
 *         – vi skal bruge backend-root, ikke /api.
 */
export function getImageUrl(path) {
  if (!path || typeof path !== 'string') return null
  const trimmed = path.trim()
  if (!trimmed) return null

  // Allerede fuld URL (https://...)
  if (trimmed.startsWith('http://') || trimmed.startsWith('https://')) {
    return trimmed
  }

  // Relativ sti (/static/...)
  const apiUrl = import.meta.env.VITE_API_URL || ''
  if (apiUrl) {
    const base = apiUrl.replace(/\/api\/?$/, '')
    return base ? `${base}${trimmed.startsWith('/') ? '' : '/'}${trimmed}` : trimmed
  }

  return trimmed
}
